export default "__VITE_ASSET__D7Q_amTB__"